<template>
  <component
    v-if="moduleMap[currentModuleId]"
    :is="moduleMap[currentModuleId]"
    :entity-uuid="worldview.uuid"
    :entity-id="worldview.id!"
    entity-type="worldview"
    @update:worldview="updateWorldview"
    :is-saving="isSaving"
    :universe-id="worldview.universeId"
    @update:is-saving="emit('update:isSaving', $event)"
  />

  <!-- 自定义模块 -->
  <CustomModule
    v-else-if="currentModuleId"
    :is-saving="isSaving"
    @update:is-saving="emit('update:isSaving', $event)"
    :module-id="currentModuleId"
  />
</template>

<script setup lang="ts">
import { Worldview } from "@/types/entity";
import type { Component as VueComponent } from "vue";
import { computed } from "vue";
import { SETTING_MODULE_ID } from "@/stores/module/moduleBase";
import {
  BASIC_INFO_MODULE_ID,
  TIMELINE_MODULE_ID,
  GALLERY_MODULE_ID,
} from "@/stores/module/moduleWorldview";
import WorldviewBasicInfoModule from "./WorldviewBasicInfoModule.vue";
import TimelineModule from "../TimelineModule.vue";
import WorldviewSettingModule from "./WorldviewSettingModule.vue";
import { useModule } from "@/stores/module";
import { useWorldview } from "@/stores/worldview";
import ModuleGallery from "../../media/ModuleGallery.vue";

const moduleStore = useModule();
defineProps<{
  currentModuleId: number;
  isSaving: boolean;
}>();

const worldviewStore = useWorldview();

const moduleMap: Record<number, VueComponent> = {
  [BASIC_INFO_MODULE_ID]: WorldviewBasicInfoModule, // 基本信息
  [TIMELINE_MODULE_ID]: TimelineModule, // 时间线
  // [BIOLOGY_MODULE_ID]: WorldviewBiologyModule, // 生物
  [GALLERY_MODULE_ID]: ModuleGallery, // 画廊
  [SETTING_MODULE_ID]: WorldviewSettingModule, // 设置
};

const worldview = computed(() => {
  return moduleStore.module!.entity as Worldview;
});
const emit = defineEmits<{
  (e: "update:isSaving", isSaving: boolean): void;
}>();

type UpdateKey = keyof Worldview;

const updateWorldview = async (updateKey: UpdateKey) => {
  emit("update:isSaving", true);

  const params: Partial<Worldview> = {};
  const value = worldview.value[updateKey];
  if (value !== undefined) {
    params[updateKey] = value;
  }

  try {
    await worldviewStore.updateWorldview(worldview.value.id!, params);
  } catch (e) {
    console.log(e);
  }

  emit("update:isSaving", false);
};
</script>
